
import { defineComponent, computed, ComputedRef } from 'vue'
import { BreakPointFlag, usePriorityBreakPoint, breakPointPriorityListAsc, customPropsType } from '@/util'

type BreakPointObjPart = { [k in BreakPointFlag]?: number }
type ColParams = number|BreakPointObjPart
type ColParamsRef = ComputedRef<ColParams>

const useColClass = (breakPoint: ReturnType<typeof usePriorityBreakPoint>, offset: ColParamsRef, span: ColParamsRef) => {
  const classList = computed(() => {
    const list = new Array<string>()
    const o = offset.value
    const s = span.value
    const bp = breakPoint.value
    // 在所有实现中优先使用最小尺寸，如果没实现，从这个位置向最大进行匹配
    if (typeof o === 'number') {
      list.push(`col-offset-${o}`)
    } else {
      const availableBreakPoint = bp.filter(flag => o[flag])[0] // 选取实现了且优先级最高的
      if (availableBreakPoint) {
        list.push(`col-offset-${o[availableBreakPoint]}`)
      } else { // 没实现进行回退
        const priorityList = breakPointPriorityListAsc
        const topPriority = bp[0]
        for (let index = priorityList.indexOf(topPriority) + 1; index < priorityList.length; index++) {
          if (o[priorityList[index]]) {
            list.push(`col-offset-${o[priorityList[index]]}`)
            break
          }
        }
      }
    }
    if (typeof s === 'number') {
      list.push(`col-span-${s}`)
    } else {
      const availableBreakPoint = bp.filter(flag => s[flag])[0]
      if (availableBreakPoint) {
        list.push(`col-span-${s[availableBreakPoint]}`)
      } else { // 没实现进行回退
        const priorityList = breakPointPriorityListAsc
        const topPriority = bp[0]
        for (let index = priorityList.indexOf(topPriority) + 1; index < priorityList.length; index++) {
          if (s[priorityList[index]]) {
            list.push(`col-span-${s[priorityList[index]]}`)
            break
          }
        }
      }
    }
    return list
  })
  return {
    classList
  }
}
export default defineComponent({
  name: 'fd-col',
  props: {
    span: customPropsType<string | ColParams>(),
    offset: {
      default: 0 as number | ColParams
    }
  },
  setup (props) {
    const breakPoint = usePriorityBreakPoint()
    const span = computed(() => {
      const s = props.span
      const res = typeof s === 'string' ? Number(s) : s
      return res
    })
    const offset = computed(() => {
      const o = props.offset
      const res = typeof o === 'string' ? Number(o) : o
      return res
    })
    const { classList } = useColClass(breakPoint, offset, span)
    return {
      classList
    }
  }
})
